<template>
	<div class="topBox">
		
		<logo @fncollect="fncollect" />
		
		<user/>
		
	</div>
</template>

<script>
  import Logo from "./Logo.vue";
  import User from "./User.vue";
  export default {
    name: "topBar",
    components: {
      Logo,
      User,
    },
	methods:{
		fncollect(e){
			let {flag} = e
			this.$emit("barcollect", {flag});
		},
	},

  }
</script>

<style scoped lang="scss">
	.topBox{
		width: 100%;
		height: 100%;
		padding: 0 18px 0 18px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		background-color: #fff;
	}
	
</style>